export const packagesHomeRootRoute = 'packages';
export const packagesCalendarRoute = 'calendar';
export const packagesResultsRootRoute = 'packages-results';
